import React, { useRef } from 'react';
import { ads_player_static_video } from '../../common/assets.common';
import { BannerWorker } from '../banner';
import ReactVideoAdsPlayer from './videoPlayerV1/ReactVideoAdsPlayer';
export default function AdsPlayer() {
  const videoRef = useRef();
  return (
    <div className="w-100 ">
      <BannerWorker page_name={'video_archive'} />
      <ReactVideoAdsPlayer
        file={ads_player_static_video}
        className="adsPlayerMain"
        page_name="video_archive"
      />

      {/* page - start */}
      {/* <VideoPlayerWithAds
        data={{
          src: 'https://videodelivery.net/d25d72e9bc8c4bba421ff13c9b7c250b/manifest/video.m3u8', //'https://iframe.videodelivery.net/3b8325b472c6fed9112dae9ba75b095e', //'https://videodelivery.net/3b8325b472c6fed9112dae9ba75b095e/manifest/video.m3u8', //"https://cdn3.wowza.com/1/ZitEazc1L0szMjZl/NFhiMGVF/hls/live/playlist.m3u8",//"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"//https://vimeo.com/672302245
          content_type: 'ads test',
          content_id: 0
        }}
        videoRef={videoRef}
      /> */}
    </div>
  );
}
